module.exports = __webpack_public_path__ + "static/media/browse.65273e62.svg";